module.exports = __webpack_public_path__ + "static/media/agradecimiento.eb3f935c.svg";